import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Eye, EyeOff } from "lucide-react";

const StnViewSingle_report = () => {
   useAuthRedirect();
    const {stnNo, stnBranch} = useParams();
  const branch = localStorage.getItem("branch");
  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);
  const [showLifeDetail, setShowLifeDetail] = useState(false);
  const navigate = useNavigate();


  const [loading, setLoading] = useState(true);

useEffect(() => {
  const fetchIndentDetails = async () => {
    setLoading(true); // start loading
    try {
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/stn_detailsHeader?stnNo=${stnNo}&branch=${stnBranch}`
      );

      if (response.data && response.data.headerDetails?.length > 0) {
        const items = response.data.headerDetails;

        const storeReqHeader = {
          stnNumber: items[0].stn_purnumber,
          stn_branch: items[0].stn_branch,
          stn_now: items[0].stn_now,
          stn_dpt: items[0].stn_dpt,
          stn_hod: items[0].stn_hod,
          stn_requbasis: items[0].stn_requbasis,
          stn_headmet: items[0].stn_headmet,
          stn_inref: items[0].stn_inref,
          stn_remarks: items[0].stn_remarks,
        };

        setHeader(storeReqHeader);
        setData(response.data.headerDetails);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
      setData([]);
    } finally {
      setLoading(false); // stop loading
    }
  };

  fetchIndentDetails();
}, [stnNo, branch]);




  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">STN Requisition - View</h2>
                    <Link to='/inventory/stnRequisitionReport'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>STN Req No :</label>
                <input type="text" name="indentNo" value={header.stnNumber} readOnly/>

              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="text"
                value={header.stn_now ? new Date(header.stn_now).toISOString().split("T")[0] : ""} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>To Branch :</label>
                <input type="text" name="type" value={header.stn_branch} readOnly />
              </div>
              <div className="form-group">
                <label>Department :</label>
                <input type="text" name="branch" value={header.stn_dpt} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>H.O.D :</label>
                <input type="text" value={header.stn_hod} readOnly/>
              </div>

              <div className="form-group">
                <label>Head Meterial:</label>
                <input type="text"value={header.stn_headmet} readOnly />
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Req Basis :</label>
                <input type="text" value={header.stn_requbasis} readOnly/>
              </div>

              <div className="form-group">
                <label>Indent Ref :</label>
                <input type="text" value={header.stn_inref} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={header.stn_remarks} readOnly/>
              </div>

              <div className="form-group">
                <label></label>
                <input type="hidden"/>
              </div>
            </div>
            
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Part No</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Due Date</th>
                    <th>Specification</th>
                    <th>Purpose</th>
                    {showLifeDetail && (
                      <th style={{ textAlign: "center" }}>
                        Life Detail
                      </th>
                    )}
                    <th>
                      <button
                        type="button"
                        onClick={() => setShowLifeDetail(!showLifeDetail)}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        {showLifeDetail ? <EyeOff size={18} /> : <Eye size={18} />}
                      </button>
                    </th>
                  </tr>
                </thead>
               <tbody>
  {loading ? (
    <tr>
      <td colSpan="10" style={{ textAlign: "center", fontWeight: "bold" }}>
        Loading...
      </td>
    </tr>
  ) : data.length > 0 ? (
    data.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.stn_itemcode}</td>
        <td>{item.stn_drawno}</td>
        <td>{item.stn_desc}</td>
        <td>{item.stn_uom}</td>
        <td>{item.stn_price}</td>
        <td>{item.stn_qty}</td>
        <td>
          {item.stn_duedate
            ? new Date(item.stn_duedate).toISOString().split("T")[0]
            : ""}
        </td>
        <td>{item.stn_specification}</td>
        <td>{item.stn_purpose}</td>
        {showLifeDetail && <td>{item.stn_lifetime}</td>}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="10" style={{ textAlign: "center" }}>
        No items
      </td>
    </tr>
  )}
</tbody>

              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default StnViewSingle_report;
